import { Pipe, PipeTransform } from '@angular/core';
import { normalizeMatchScore } from './match-score-utils';

@Pipe({
  name: 'matchScoreNormalized',
  standalone: true
})
export class MatchScoreNormalizedPipe implements PipeTransform {
  /**
   * Transform match score to normalized numeric percentage (for progress bars).
   *
   * Uses normalization to stretch the typical score range (0.4-0.95) to 0-100
   * for better visual representation in progress bars.
   *
   * @param score - Raw similarity score (0-1) or percentage (0-100)
   * @returns Normalized percentage as number (0-100)
   */
  transform(score: number | null | undefined): number {
    return normalizeMatchScore(score);
  }
}
